import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';

const special = {
    state: {

    },
    mutations: {

    },
    actions: {
        //获取专题列表
        themeArticleList(actions, data) {
            return request({
                url: `${projectName}/themeArticle/list`,
                method: 'get',
            })
        },
        //保存专题
        themeArticleSaveOrUpdate(actions, data) {
            return request({
                url: `${projectName}/themeArticle/saveOrUpdate`,
                method: 'post',
                data
            })
        },
        //详情
        themeArticleDetail(actions, data) {
            return request({
                url: `${projectName}/themeArticle/detail`,
                method: 'post',
                data
            })
        },
        //删除
        themeArticleRemove(actions, data) {
            return request({
                url: `${projectName}/themeArticle/remove`,
                method: 'post',
                data
            })
        },
        //服务列表
        themeArticleServiceList(actions, data) {
            return request({
                url: `${projectName}/serviceInfo/richTextEditor/serviceList`,
                method: 'post',
                data
            })
        },
        //公众号消息列表（新增）
        themeArticleMpMessageList(actions, data) {
            return request({
                url: `${projectName}/themeArticle/richTextTitle/mpMessageList`,
                method: 'post',
                data
            })
        },
        //公众号列表（新增）
        themeArticleMpInfoList(actions, data) {
            return request({
                url: `/api/blade-workbench/im/mp/mpInfoList`,
                method: 'post',
                data
            })
        },

    }
}
export default special
